export abstract class IServerService {
    public abstract Initialize():Promise<void>;
}

export class FakeServerService extends IServerService{
    public Initialize(): Promise<void> {
        return Promise.resolve();
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/server/IServerService.ts